import React from 'react';
import styled from 'styled-components';
import { Eye } from '@styled-icons/heroicons-outline';
import { Download } from '@styled-icons/boxicons-regular';
import { Delete } from '@styled-icons/fluentui-system-regular';
import { Grid, IconButton, Tooltip } from '@material-ui/core';

const iconWidth = '1.8rem';
const iconHeight = '1.8rem';
const iconColor = 'darkgray';

const ViewIcon = styled(Eye)`
  color: ${iconColor};
  width: ${iconWidth};
  height: ${iconHeight};
`;
const DownloadIcon = styled(Download)`
  color: ${iconColor};
  width: ${iconWidth};
  height: ${iconHeight};
`;
const DeleteIcon = styled(Delete)`
  color: ${iconColor};
  width: ${iconWidth};
  height: ${iconHeight};
`;

const SquareIcon = styled.div`
  width: ${iconWidth};
  height: ${iconHeight};
  background-color: #e7e7e7;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Actionbar({
  handlers: { handleView, handleDownload, handleCancel },
  id,
  row,
}) {
  const opStatus = parseInt(row.id_ob_operation_status);
  return (
    <Grid container direction="row" justify="flex-start" alignItems="center">
      <Grid item>
        {[1, 2, 3, 4, 5, 6, 7].includes(opStatus) && (
          <Tooltip title="Ver operación">
            <IconButton onClick={() => handleView(id, row)}>
              <SquareIcon>
                <ViewIcon />
              </SquareIcon>
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      <Grid item>
        {[3].includes(opStatus) && (
          <Tooltip title="Descargar documentos de operación">
            <IconButton onClick={() => handleDownload(id, row)}>
              <SquareIcon>
                <DownloadIcon />
              </SquareIcon>
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      <Grid item>
        {[1,2,4].includes(opStatus) && (
          <Tooltip title="Cancelar operación">
            <IconButton onClick={() => handleCancel(id)}>
              <SquareIcon>
                <DeleteIcon />
              </SquareIcon>
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
}

export default Actionbar;
